import { Component, OnInit } from '@angular/core';
import { CreateJobPostModel } from "../../../models/inModels/JobPost";
import { Message } from "primeng/components/common/message";
import { SelectItem } from "primeng/components/common/selectitem";
import { BusinessService } from "../../../services/business/business-category.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { JobPostService } from "../../../services/business/job-post.service";

@Component({
	selector: 'app-job-posts-create',
	templateUrl: './job-posts-create.component.html',
	styleUrls: ['./job-posts-create.component.css']
})
export class JobPostsCreateComponent {
	model: CreateJobPostModel;
	loading = false;
	error: Message[];
	categories: SelectItem[];
	selectedCategory;
	constructor(
		private auth: AuthenticationService,
		private router: Router,
		private service: JobPostService,
		private businessService: BusinessService) {
		this.model = new CreateJobPostModel();
		this.model.Push = true;
		this.model.Email = true;
	}

	initCategoryDropDown(event) {
		this.businessService.getDropdown(event).then(
			x => {
				this.categories = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setCategory(): void {
		this.model.businessCategoryId = this.selectedCategory.value;
	}

	goBack(): void {
		this.router.navigate(['/jobposts']);
	}
	

	save() {
		console.log(this.model);
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/job-posts/job-posts-create/job-posts-create.component.ts